import OrderAddRequest, {
  OrderAddBody,
  OrderAddQueryParams,
} from "./order-add-request";

const createBody = (request: OrderAddRequest): OrderAddBody => {
  return {
    cargoTaxiContractId: request.cargoTaxiContractId,
    externalId: request.externalId,
    railyRide: request.railyRide,
    targetTaxiId: request.targetTaxiId,
  };
};

const createQueryParams = (request: OrderAddRequest): OrderAddQueryParams => {
  return {
    assumeDispatcherId: request.assumeDispatcherId,
  };
};

const orderAddRequestFactory = {
  createBody,
  createQueryParams,
};

export default orderAddRequestFactory;
